import { LIMIT } from '@/constants';
import { Sort } from '@/types';
import {
  fetchAddDistributorShareProductDocumenet,
  fetchDistributorBindingCustomerDetailDocument,
  fetchDistributorBindingCustomersDocument,
  fetchDistributorBindingMembersDocument,
  fetchDistributorCenterDocument,
  fetchDistributorPerformanceDocument,
  fetchDistributorShareProductsDocument,
  fetchDistributorsPromoteOrdersDocument,
  fetchSetDistributorBindingRemarkDocument,
} from '../graphql/docs';
import { fetcher } from '../graphql/fetcher';

/**
 * 获取分销中心数据
 * @returns
 */
export const fetchDistributorCenter = async (startDateTime: string, endDateTime: string) => {
  const res = await fetcher.query(fetchDistributorCenterDocument, {
    variables: {
      startDateTime,
      endDateTime,
    },
  });
  return res.data.value?.distributorCenter;
};

/**
 * 获取分销中心-业绩统计数据
 * @returns
 */
export const fetchDistributorPerformance = async (
  dateTime: {
    startDateTime: string;
    endDateTime: string;
  } = { startDateTime: '', endDateTime: '' }
) => {
  const res = await fetcher.query(fetchDistributorPerformanceDocument, {
    variables: {
      startDateTime: dateTime.startDateTime,
      endDateTime: dateTime.endDateTime,
    },
  });
  return res.data.value?.distributorPerformance;
};

/**
 * 获取分销中心-推广订单数据
 * @returns
 */
export const fetchDistributorsPromoteOrders = async (variables: AnyObject) => {
  const res = await fetcher.query(fetchDistributorsPromoteOrdersDocument, {
    variables: {
      ...variables,
      options: {
        skip: LIMIT * variables.options.skip,
        take: LIMIT,
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value?.distributorsPromoteOrders;
};

/**
 * 获取分销中心-推广商品数据
 * @returns
 */
export const fetchDistributorShareProducts = async (variables: AnyObject) => {
  const res = await fetcher.query(fetchDistributorShareProductsDocument, {
    variables: {
      ...variables,
      options: {
        skip: LIMIT * variables.options.skip,
        take: LIMIT,
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value?.distributorShareProducts;
};

/**
 * 分销员点赚添加推广商品
 * @param productId
 * @returns
 */
export const fetchAddDistributorShareProduct = async (productId: string) => {
  const res = await fetcher.mutation(fetchAddDistributorShareProductDocumenet, {
    productId,
  });
  return res.data?.addDistributorShareProduct;
};

/**
 * 获取分销中心-分销员下的用户信息数据
 * @returns
 */
export const fetchDistributorBindingCustomers = async (variables: AnyObject) => {
  const res = await fetcher.query(fetchDistributorBindingCustomersDocument, {
    variables: {
      ...variables,
      options: {
        skip: LIMIT * variables.options.skip,
        take: LIMIT,
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value?.distributorBindingCustomers;
};

/**
 * 获取分销中心-分销员下的用户详情接口数据
 * @returns
 */
export const fetchDistributorBindingCustomerDetail = async (customerId: string) => {
  const res = await fetcher.query(fetchDistributorBindingCustomerDetailDocument, {
    variables: {
      customerId,
    },
  });
  return res.data.value?.distributorBindingCustomerDetail;
};

/**
 * 获取分销中心-分销员下的用户详情设置备注
 * @returns
 */
export const fetchSetDistributorBindingRemark = async (customerId: string, remark: string) => {
  const res = await fetcher.mutation(fetchSetDistributorBindingRemarkDocument, {
    customerId,
    remark,
  });
  return res.data?.setDistributorBindingRemark;
};

/**
 * 分销中心-查询新增开卡用户
 * @param options - search、startDateTime、endDateTime、state、skip、take
 * @returns
 */
export const fetchDistributorBindingMembers = async (options: AnyObject) => {
  const res = await fetcher.query(fetchDistributorBindingMembersDocument, {
    variables: {
      ...options,
      take: 10,
    },
  });
  return res.data.value?.distributorBindingMembers;
};
